// Plain (non-component) helpers shared by the portal pages. Kept out of the
// .tsx modules so React Fast Refresh can hot-swap those.
import type { VMilestone, VRelease } from "../data";

/** The release a project is working towards: On sandbox, else Open, else Planning. */
export function currentRelease(releases: VRelease[], projectId: string): VRelease | undefined {
  const rs = releases.filter((r) => r.projectId === projectId && !r.isFixes);
  return (
    rs.find((r) => r.status === "On sandbox") ??
    rs.find((r) => r.status === "Open") ??
    rs.find((r) => r.status === "Planning")
  );
}

/** Milestones of one project in timeline order. */
export function projectMilestones(milestones: VMilestone[], projectId: string): VMilestone[] {
  return milestones
    .filter((m) => m.projectId === projectId)
    .sort((a, b) => a.sortOrder - b.sortOrder || (a.dateAt ?? 0) - (b.dateAt ?? 0));
}

export const plural = (n: number, word: string, many = `${word}s`) =>
  `${n} ${n === 1 ? word : many}`;

export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? "";

/** "Today, 10:44" / "Yesterday, 16:10" / "Tue 6 Oct, 14:20". */
export function activityWhen(ms: number): string {
  const d = new Date(ms);
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${activityDay(ms)}, ${time}`;
}

/** Day label for grouping activity: Today / Yesterday / "Tue 6 Oct". */
export function activityDay(ms: number): string {
  const d = new Date(ms);
  const today = new Date();
  const start = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((start(today) - start(d)) / 86_400_000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  return d.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(d.getFullYear() !== today.getFullYear() ? { year: "numeric" } : {}),
  });
}
